import tableTitleBarStyles from './TableTitleBar.module.scss';
import {ReactElement} from 'react'

class TableTitleBarProps {
    /**
     * @type {!string}
     */
    title;

    /**
     * @type {ReactElement | ReactElement[]}
     */
    children;
}

/**
 * @param {TableTitleBarProps} props
 */
export default function TableTitleBar(props) {
    return (
        <div className={tableTitleBarStyles.container}>
            <span className={tableTitleBarStyles.title}>
                {props.title}
            </span>
            <div className={tableTitleBarStyles.btnAndInputConatiner}>
                {
                    Array.isArray(props.children)
                        ? props.children.map(child => child)
                        : props.children
                }
            </div>
        </div>
    );
}
